import React, { useContext } from 'react'

import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'

import SearchCheckbox from '../../../../Components/antd/Selects/SearchCheckbox'
import InstitutionSchoolsList from '../../Quotas/SchoolQuotasView/InstitutionSchoolsList'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { calc, pc, px } from '../../../../utils/cssHelper'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const PADDING = 12

const Settings = ({ schools, onSelectSectors, onSelectSchools, t }) => {
  const { sectors, loading } = useContext(InstitutionContext)

  return (
    <div className={'settings h-100 pd-' + PADDING}>
      <div style={{ height: '30%' }}>
        <SearchCheckbox
          checkAllOption
          items={sectors}
          labelKey='name'
          loading={loading}
          tooltipKey='name'
          title={t('common.sectors')}
          valueKey='id'
          style={{ height: '100%', margin: '0px' }}
          onCheck={onSelectSectors}
          onCheckAll={onSelectSectors}
        />
      </div>
      <div className='mt-8' style={{ height: calc(pc(70), '-', px(PADDING * 5)) }}>
        <InstitutionSchoolsList selected={schools.map(s => s.id)} onSelect={onSelectSchools} />
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(Settings)
